<template>
  <div class="clazz_cycle" v-if="clazz && isCheck">
    <div class="header">
      <clazz-header :clazz="clazz" />
    </div>

    <div class="tips after_border bgwhite">
      <!-- <div class="item" @click="showMask">
        <div class="icon"><van-icon name="share" /></div>
        <div class="label">分享</div>
      </div> -->
      <!-- <div v-if="dakaCheck.is_leader" class="item" @click="gotoManageClazzUser"> -->
      <div class="item" @click="gotoManageClazzUser">
        <div class="icon"><van-icon name="manager-o" /></div>
        <div class="label">成员({{ clazz.user_num }})</div>
      </div>
      <div class="item" @click="gotoReport">
        <div class="icon"><van-icon name="todo-list-o" /></div>
        <div class="label">统计</div>
      </div>
      <!-- <div class="item" @click="gotoRank">
        <div class="icon"><van-icon name="diamond-o" /></div>
        <div class="label">排行</div>
      </div> -->
      <div v-if="dakaCheck.in_clazz" class="item" @click="gotoData">
        <div class="icon"><van-icon name="bar-chart-o" /></div>
        <div class="label">打卡日历</div>
      </div>
      <div class="item" @click="gotoReview">
        <div class="icon"><van-icon name="completed" /></div>
        <div class="label">审核</div>
      </div>
    </div>
    <div class="tips after_border bgwhite">
      <div class="item" @click="show=true">
        <div class="icon"><van-icon name="chat-o" /></div>
        <div class="label">联系班长</div>
      </div>
      <div class="item" @click="gotoCard">
        <div class="icon"><van-icon name="diamond-o" /></div>
        <div class="label">完赛证书</div>
      </div>
    </div>

    <div class="cell bgwhite">打卡记录</div>

    <class-recod-list :clazz-id="clazz.uuid" @delete="checkDaka" />

    <tabbar-top/>
    <bottom-btn
      v-if="dakaCheck.in_clazz && dakaCheck.status != 99"
      :title="dakaCheck.msg"
      :fixed="true"
      :disabled="dakaCheck.status!==0"
      @click.native="gotoDaka"
    />
    <goto-home />

    <div class="mask" v-show="mask" @click="closeMask">
      <img src="../../assets/images/guide.png">
    </div>

    <van-dialog v-model="show">
      <div v-if="clazz.creater_weixin" class="weixin_contract">
        <img :src="clazz.creater_weixin_qrcode">
        <!-- 请添加班长微信：{{ clazz.creater_weixin }} -->
      </div>
      <div v-else class="weixin_contract">班长未设置联系方式</div>
    </van-dialog>
  </div>
</template>

<script>
import { Icon, Cell } from 'vant'
import ClazzHeader from './components/ClazzHeader'
import ClassRecodList from '@/views/clazz/components/ClassRecodList'
import TabbarTop from '@/components/TabbarTop'
import BottomBtn from '@/components/BottomBtn'
import GotoHome from '@/components/GotoHome'
import { clazzSimpleInfo, checkMyClazzCard } from '@/api/clazz'
import { checkAddRecord } from '@/api/record'

export default {
  name: 'ClazzCycle',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    ClazzHeader,
    TabbarTop,
    GotoHome,
    ClassRecodList,
    BottomBtn
  },
  data () {
    return {
      show: false,
      mask: false,
      clazz: null,
      isCheck: false,
      dakaCheck: {
        in_clazz: false,
        is_leader: false,
        status: 99,
        msg: ''
      }
    }
  },
  created () {
    let clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      this.clazz = response.data
      this.checkDaka()
    },
    async checkDaka () {
      let response = await checkAddRecord(this.clazz.uuid)
      this.dakaCheck = response.data
      this.isCheck = true
    },
    showMask () {
      this.mask = true
    },
    closeMask () {
      this.mask = false
    },
    gotoManageClazzUser () {
      this.$router.push('/manage/clazz/' + this.clazz.uuid + '/user')
    },
    gotoRank () {
      this.$router.push('/join/clazz/' + this.clazz.uuid + '/rank')
    },
    gotoRule () {
      this.$router.push('/clazz/' + this.clazz.uuid + '/rule')
    },
    gotoData () {
      this.$router.push('/join/clazz/' + this.clazz.uuid + '/data')
    },
    gotoReview () {
      this.$router.push('/join/clazz/' + this.clazz.uuid + '/review')
    },
    gotoReport () {
      this.$router.push('/join/clazz/' + this.clazz.uuid + '/week/report')
    },
    async gotoCard () {
      await checkMyClazzCard({ clazz_id: this.clazz.uuid })
      this.$router.push(`/my/clazz/card?clazz_id=${this.clazz.uuid}`)
    },
    gotoDaka () {
      if (!this.dakaCheck.in_clazz || this.dakaCheck.status !== 0) {
        return false
      }
      this.$router.push(`/daka?clazz_id=${this.clazz.uuid}`)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_cycle {
  background-color: #f8f8f8;
  .header {
    background-color: #343344;
    // background-color: #333a46;
    // background-color: #282c34;
    // padding: 15px 0;
    height: 200px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tips {
    padding: 25px 0;
    display: flex;
    // justify-content: space-around;
    .item {
      font-size: 28px;
      width: 180px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .icon {
        font-size: 40px;
      }
    }
  }
  .cell {
    padding: 20px 0 20px 30px;
    font-size: 28px;
  }
  .empty {
    font-size: 26px;
    height: 100px;
    padding-bottom: 60px;
  }
  .mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.6;
    z-index: 999;
    img {
      position: fixed;
      width: 550px;
      right: 0;
    }
  }
  .weixin_contract {
    padding: 30px 0;
    text-align: center;
    display: flex;
    justify-content: center;
  }
}
</style>
